// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Modal from '../../../../../../common/molecules/Modal/view/Modal';

export const StyledCategoryPromotionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 16px;
  margin-top: 4px;
  @media ${(props) => props?.theme?.mediaQuery?.large} {
    padding-bottom: 24px;
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const StyledLongDescription = styled(BodyCopy)`
  line-height: 33px;
`;

export const StyledSubHeadingWrapper = styled.div`
  display: flex;
  padding-top: 2px;
  @media ${(props) => props?.theme?.mediaQuery?.large} {
    padding-top: 4px;
  }
`;

export const StyledSubHeading = styled(BodyCopy)`
  line-height: 33px;
`;

export const StyledDetails = styled(BodyCopy)`
  padding-left: 8px;
  line-height: 33px;
  cursor: pointer;
  text-decoration-line: underline;
`;

export const StyledModal = styled(Modal)`
  .category-promotion-tnc-modal {
    .TCPModal__InnerContent {
      max-height: 90%;
    }
    .alignTop {
      top: 5px;
      right: 12px;
    }
  }
`;
